import React from 'react';

import {useI18n} from '../../../../data/hooks/i18nHooks';
import Link from '../../../elements/Link';

const FavoriteCount = props => {
    let {question} = props,
        count = question.favorite_users?.length || 0,
        i18n = useI18n(),
        content = (
            <span>
                {count} {count != 1 ? i18n['button.likes'] : i18n['button.like']}
            </span>
        );

    if (count) {
        return <Link href="./favorited">{content}</Link>;
    } else {
        return content;
    }
};

export default FavoriteCount;
